// extracted by mini-css-extract-plugin
module.exports = {"root":"Body_root__3-GJH"};